import { Component, Input, ViewEncapsulation } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-welcome-first-time-onboarding-body",
  standalone: true,
  exportAs: "welcomeFirstTimeOnboardingBody",
  imports: [CommonModule, TranslateModule],
  templateUrl: "./welcome-first-time-onboarding-body.component.html",
  styleUrls: ["./welcome-first-time-onboarding-body.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class WelcomeFirstTimeOnboardingBodyComponent {
  @Input() userName = "there";
  @Input() momentStep = "welcomeFirstTimeOnboarding";

  showActions = true;
}
